module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), (_vm.mostrarModalRechazo) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "overlay-class"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("Motivo de rechazo")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivoRechazo),
      expression: "motivoRechazo"
    }],
    staticClass: "p-10",
    attrs: {
      "name": "motivoRechazo",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.motivoRechazo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivoRechazo = $event.target.value
      }
    }
  })]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.rechazar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Rechazar...")]) : _c('span', [_vm._v("Rechazar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.cerrarModalRechazo
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])]) : _vm._e(), (_vm.mostrarModalNotificar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarNotificar",
    on: {
      "close": _vm.closeModalNotificar,
      "do": _vm.notificar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea notificar a todos los empleados que no hayan cargado su documento?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Notificando...")]) : _c('span', [_vm._v("Notificar")])]), _c('strong', [_vm._v("Este proceso no se puede deshacer")])])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.codigoEmpleado),
      expression: "filtros.codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtros.codigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "codigoEmpleado", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtros.codigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtros.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Documento")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.id),
      expression: "filtros.id"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Ninguno")]), _vm._l((_vm.documentos), function(documento) {
    return _c('option', {
      domProps: {
        "value": documento.id
      }
    }, [_vm._v(_vm._s(documento.descripcion))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.estado),
      expression: "filtros.estado"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Sin carga")]), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Sin revisar")]), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Revisado")])])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("¿Documentos activos?")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.activo),
      expression: "filtros.activo"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "activo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Si")]), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("No")])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button m-5",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button m-5",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button m-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.notificar()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw fa-lg"
  })]), _c('span', [_vm._v("Notificar Masivo")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.lista.length !== 0) ? _c('table', {
    key: "lista",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Doc.")]), _c('th', [_vm._v("Empleado")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      }
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcion))])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))]), (o.rutaSubido) ? [_c('div', {
      staticClass: "seen"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Subido")]), _c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check fs-12"
    })])]), _c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Fecha Subido: ")]), _c('span', [_vm._v(_vm._s(o.fechaSubidoArchivoEmpleado))])])] : _vm._e()], 2)]), _c('td', [_c('div', {
      staticClass: "text-center flex fdc"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(o.rutaSubido) ? _c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.rutaSubido,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye is-small fs-12"
    })]), _c('span', [_vm._v("Revisar")])]) : _vm._e(), (o.rutaSubido && !o.revisado) ? _c('button', {
      staticClass: "button is-small",
      class: {
        'is-loading': _vm.isProcessing
      },
      on: {
        "click": function($event) {
          return _vm.revisar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-check is-small fs-12"
    })]), _c('span', [_vm._v("Aprobar")])]) : _vm._e(), (!o.rutaSubido) ? _c('button', {
      staticClass: "button is-small is-primary mt-5",
      on: {
        "click": function($event) {
          return _vm.notificar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-envelope fs-12"
    })]), _c('span', [_vm._v("Notificar")])]) : _vm._e(), (o.rutaSubido) ? _c('button', {
      staticClass: "button is-small is-danger mt-5",
      on: {
        "click": function($event) {
          return _vm.abrirModalRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash fs-12"
    })]), _c('span', [_vm._v("Rechazar")])]) : _vm._e()])])])])
  }), 0)], 1) : _vm._e()])], 1), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe información con los filtros definidos")])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de Documentos para Firmar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0634b2c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Reporte_Documentos_Firmar.vue
// module id = 873
// module chunks = 0